import api from "./api"

const cleanParams = (params = {}) => {
  const result = {}

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value
    }
  })

  return result
}

export const getDebtPayments = async (params = {}) => {
  const response = await api.get("/debt-payments", {
    params: cleanParams(params),
  })

  return response.data
}

export const getDebtPaymentById = async (paymentId) => {
  if (!paymentId) {
    throw new Error("paymentId is required")
  }

  const response = await api.get(`/debt-payments/${paymentId}`)
  return response.data
}

export const getDebtPaymentFormData = async (includeDebtId = null) => {
  const response = await api.get("/debt-payments/form-data", {
    params: cleanParams({
      include_debt_id: includeDebtId,
    }),
  })

  return response.data
}

export const createDebtPayment = async (payload) => {
  const response = await api.post("/debt-payments", payload)
  return response.data
}

export const updateDebtPayment = async (paymentId, payload) => {
  if (!paymentId) {
    throw new Error("paymentId is required")
  }

  const response = await api.put(
    `/debt-payments/${paymentId}`,
    payload
  )

  return response.data
}

export const deleteDebtPayment = async (paymentId) => {
  if (!paymentId) {
    throw new Error("paymentId is required")
  }

  const response = await api.delete(
    `/debt-payments/${paymentId}`
  )

  return response.data
}